var Eqa = window.Eqa = window.Eqa || {};

window.Eqa.ShareLinks = (function() {
  function init() {
    enableNativeShare();
  }
  
  function enableNativeShare() {
    if (!isTouchDevice()) { return false; }
    if (!navigator.share) { return false; }
    
    const shareLink = document.querySelector('.shareLinkWrap--share .shareLink')
    if (!shareLink) { return false; }
    
    const shareLinksWrap = shareLink.closest('.shareLinks');
    
    if (!shareLinksWrap) { return false; }
    
    shareLinksWrap.classList.add('shareLinks--nativeShareEnabled');
    
    shareLink.addEventListener('click', (e) => {
      e.preventDefault();
      
      const shareData = {
        title: shareLink.dataset.shareTitle,
        url: shareLink.dataset.shareUrl
      };

      navigator.share(shareData)
      .catch(err => {
        if (err.toString().includes('AbortError')) {
          return;
        }
      });
    });
  }
  
  function isTouchDevice() {
    return (('ontouchstart' in window) ||
       (navigator.maxTouchPoints > 0) ||
       (navigator.msMaxTouchPoints > 0));
  }

  return { init };
})();